<template>
  <section id="StatHeadlines">
    <div>
      This year, Truecaller has blocked and identified
      <span class="highlight bg-purple">31.3 billion</span> spam calls.
    </div>
    <div>
      A total of <span class="highlight bg-green">12.8 billion</span> spam messages have been blocked by Truecaller
    </div>
    <div>
      Truecaller also helped you identify <span class="highlight bg-red">1.5 billion</span> unknown unique numbers
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style>
#StatHeadlines {
  justify-content: space-around;
  background-color: var(--blue);
  background-image: url("../assets/images/bg-pattern.png");
  background-position: center center;
  background-size: cover;
  padding: 20px;
}

#StatHeadlines > div {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.83px;
  max-width: 1160px;
  margin: 64px auto;
}

#StatHeadlines > div > span {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
}

@media screen and (min-width: 720px) {
  #StatHeadlines > div {
    font-weight: 700;
    font-size: 60px;
    line-height: 73px;
    letter-spacing: -2.07px;
  }
}
</style>